export default ({ frameId, url, param = 'sort' } = {}) => ({
  onSort(value) {
    const frame = document.getElementById(frameId)
    if (!frame) return

    const next = new URL(url, location.origin)
    if (value) next.searchParams.set(param, value)
    frame.src = next.toString()
  },
})
